import { Box, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";
import { dotContainerStyle, dotStyle, headCellStyle } from "../data/styles";
import "../data/styles.css";
import { doc, getDocs, setDoc, collection, updateDoc, query, orderBy } from "firebase/firestore";
import { db } from "../services/firebase";
import { v4 as uuidv4 } from "uuid";

const GenerateCoupons = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [coupons, setCoupons] = useState([]);

    useEffect(() => {
        if (!localStorage.getItem("invCreator")) {
            navigate("/login-creator");
        }
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            const couponsCollection = collection(db, "txcc");
            const q = query(couponsCollection, orderBy("createdAt", "desc"));
            const querySnapshot = await getDocs(q);

            const fetchedCoupons = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setCoupons(fetchedCoupons);
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };

    const toggleUsageStatus = async (id, currentStatus) => {
        try {
            const couponRef = doc(db, "txcc", id);
            await updateDoc(couponRef, { usageStatus: !currentStatus });
            fetchCoupons(); // Refresh data after update
        } catch (error) {
            console.error("Error updating coupon:", error);
        }
    };

    const onGenerateClick = async () => {
        setLoading(true);
        try {
            // Generate coupon code
            const randomCode = `TX${uuidv4().slice(0, 4).toUpperCase()}`;

            // Create coupon document data
            const couponData = {
                createdAt: new Date().toISOString().split('T')[0],
                usageStatus: true,
                usedBy: null,
                couponCode: randomCode
            };

            // Store in Firestore with the generated code as the document ID
            await setDoc(doc(db, "txcc", randomCode), couponData);

            alert(`Coupon code ${randomCode} has been generated and stored successfully.`);
            fetchCoupons();
        } catch (error) {
            console.error("Error generating coupon:", error);
            alert("An error occurred while generating the coupon.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            <AdminHeaderComp />
            <Box sx={{
                width: "100vw",
                minHeight: "calc(100vh - 3.5rem)",
                backgroundColor: "#0f172a",
                display: "flex",
                justifyContent: "center",
            }}>
                <Box sx={{
                    width: "95%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1.5rem",
                    py: "1rem",
                }}>

                    <Button
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        onClick={() => onGenerateClick()}
                        sx={{ mt: { md: "1rem" } }}
                    >
                        {loading ? (
                            <Box sx={{ ...dotContainerStyle, }}>
                                <Box sx={{ ...dotStyle, animationDelay: '0s' }}></Box>
                                <Box sx={{ ...dotStyle, animationDelay: '0.2s' }}></Box>
                                <Box sx={{ ...dotStyle, animationDelay: '0.4s' }}></Box>
                                <Box sx={{ ...dotStyle, animationDelay: '0.6s' }}></Box>
                                <Box sx={{ ...dotStyle, animationDelay: '0.8s' }}></Box>
                            </Box>
                        ) : (
                            "Generate Coupon Code"
                        )}
                    </Button>

                    <TableContainer component={Paper} sx={{ maxWidth: { xs: "100%", md: "60%" } }}>
                        <Table>
                            <TableHead sx={{ backgroundColor: "#3e8596" }}>
                                <TableRow>
                                    <TableCell sx={headCellStyle}>Created At</TableCell>
                                    <TableCell sx={headCellStyle}>Coupon Code</TableCell>
                                    <TableCell sx={headCellStyle}>Used By</TableCell>
                                    <TableCell sx={headCellStyle}>Usage Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {coupons.map((coupon, index) => (
                                    <TableRow
                                        key={coupon.id}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? "white" : "lightgrey",
                                            "&:hover td": {
                                                color: "green",
                                            },
                                        }}
                                    >
                                        <TableCell>{coupon.createdAt}</TableCell>
                                        <TableCell>{coupon.couponCode}</TableCell>
                                        <TableCell>{coupon.usedBy || "Not Used"}</TableCell>
                                        <TableCell>
                                            <Switch
                                                checked={coupon.usageStatus}
                                                onChange={() => toggleUsageStatus(coupon.id, coupon.usageStatus)}
                                                color="primary"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Box>
    )
}
export default GenerateCoupons;